import { render, staticRenderFns } from "./StatusMaterialINCIRegulation.vue?vue&type=template&id=0d059e92&scoped=true&"
import script from "./StatusMaterialINCIRegulation.vue?vue&type=script&lang=js&"
export * from "./StatusMaterialINCIRegulation.vue?vue&type=script&lang=js&"
import style0 from "./StatusMaterialINCIRegulation.vue?vue&type=style&index=0&id=0d059e92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d059e92",
  null
  
)

export default component.exports